// extracted by mini-css-extract-plugin
export var container = "PreviewIndicator-module--container--9a99d";
export var indicatorIcon = "PreviewIndicator-module--indicatorIcon--bb151";